import { Routes, Route, Outlet } from 'react-router-dom'

import ProtectedRoutes from './ProtectedRoutes'
import ProtectedAuth from './ProtectedAuth'
import ProtectedGoogleAuth from './ProtectedGoogleAuth'

import Login from "../screens/Login"
import GoogleLogin from '../screens/GoogleLogin'
import DashboardLayout from '../layouts/DashboardLayout'
import Home from '../screens/Home'
import ImpactDashboard from '../screens/ImpactDashboard'
import Users from '../screens/Users'
import Donations from '../screens/donations'
import FieldSales from '../screens/FieldSales'

import ErrorPage from "../screens/ErrorPage/ErrorPage"


const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<ProtectedAuth />}>
        <Route path="login" element={<Login />} />
        <Route path="google-login" element={<GoogleLogin />} />
      </Route>
      <Route element={<ProtectedRoutes />}>
        <Route element={<DashboardLayout />}>
          <Route index element={<ImpactDashboard />} />
          <Route path="explore" element={<Home />} />
          <Route path="users" element={<Users />} />
          <Route path="donations" element={<Donations />} />
        </Route>
      </Route>
      <Route path="fieldsales" element={<ProtectedGoogleAuth />}>
        <Route index element={<FieldSales />} />
      </Route>
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  )
}

export default AppRoutes